module.exports = __webpack_public_path__ + "media/fart.4e04011b.mp3";